<template>
    <div class="relative shrink-0">
        <button @click="submit()" type="submit" :disabled="loading" :class="loading ? 'loadingButton' : disabled ? 'disabledButton' : 'primaryButton'">
            <div v-if="loading" class="flex gap-2">
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>                
                 <div class="">{{labelProcess ?? $t('buttons.saving')}}</div>
            </div>
            <div v-else>
                {{label}}
            </div>
        </button>
        <div v-if="disabled" class="absolute top-0 right-0 w-full h-full"></div>

    </div>
</template>

<script>


export default {
    name: "SubmitButton",

    props:{
        submit: Function,
        label: {
            type: String,
            default: 'Submit',
            required: false
        },
        labelProcess: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            label: String,
            default: false
        },
        disabled: {
            type: Boolean,
            label: String,
            default: false
        },
        
    },

    data() {
        return {
            errors: {},           
        }
    },

    components: {

    },
    
}
</script>
